import comp from "./AIPanelLanguageSwitch";
export default comp;
